import request from '@/utils/request';

export const getLocations = () => request({
  url: '/locations',
  method: 'get',
});
